import { KPI_IMPORT_MAX_UPLOAD_BYTES } from './constants'
import { isValidFileExtension } from './validate'

export type KpiImportFileValidationError = {
  message: string
  title: string
}

/** backend が生成した末尾改行付き CSV に UTF-8 BOM を付与する。 */
export function buildKpiTemplateCsvBlob(template: string): Blob {
  const bom = new Uint8Array([0xef, 0xbb, 0xbf])
  return new Blob([bom, template], { type: 'text/csv;charset=utf-8' })
}

/** KPI 入稿ファイルの空・拡張子・10MB 上限を順に検証する。 */
export function validateKpiImportFile(
  file: File,
  allowedExtensions: readonly string[],
): KpiImportFileValidationError | null {
  if (file.size === 0) {
    return {
      message: '空のファイルは取り込めません。',
      title: 'ファイルサイズエラー',
    }
  }

  if (!isValidFileExtension(file, [...allowedExtensions])) {
    return {
      message: `${allowedExtensions.map((extension) => `.${extension}`).join(' または ')} ファイルを選択してください。`,
      title: '形式エラー',
    }
  }

  if (file.size > KPI_IMPORT_MAX_UPLOAD_BYTES) {
    return {
      message: 'ファイルサイズが上限 10MB を超えています。',
      title: 'ファイルサイズエラー',
    }
  }

  return null
}

/** バイト数を画面表示用の KB / MB 表記へ整形する。 */
export function formatFileSize(fileSize: number): string {
  const megabyte = 1024 * 1024
  const unit = fileSize < megabyte ? 'KB' : 'MB'
  const divisor = fileSize < megabyte ? 1024 : megabyte
  return `${(fileSize / divisor).toFixed(1)} ${unit}`
}
